// extracted by mini-css-extract-plugin
module.exports = {"container":"Packages-module__container___yPq5D","heading":"Packages-module__heading___OIzJt","carouselContainer":"Packages-module__carouselContainer___kUef+"};